<template>
  <div class="container">
    <div class="item title">
      <span class="time">时间</span>
      <span class="price">成交价</span>
      <span class="vol">成交量</span>
    </div>
    <section id="tick-content" class="content" @scroll="manualScroll">
      <p class="item" v-for="item in tick" :key="item.ID">
        <span class="time">{{item.Time | formatTime}}</span>
        <span class="price" :class="getColor(item.Price)">{{item.Price | formatPrice(precision)}}</span>
        <span class="vol" :class="{'tiny-font':item.Volume / singleHand>=10000}" :style="{color: getColorValue(item.Property)}">{{item.Volume | formatVol(singleHand)}}</span>
      </p>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {formatUnit} from '@/utils'
import moment from 'moment'
import config from '@/utils/chart/config'

export default {
  data() {
    return {
      precision: 2,
      singleHand: 1,
      localTick: []
    }
  },
  computed: {
    ...mapState(['tick', 'statistic', 'region'])
  },
  filters: {
    formatTime(val) {
      return moment(val * 1000).format('HH:mm')
    },
    formatPrice(val, base) {
      return val && val.toFixed(base)
    },
    formatVol(val, base) {
      return formatUnit(val / base, false, true, 0)
    }
  },
  watch: {
    tick() {
      this.localTick = this.tick.slice(-50)
      this.toBottom()
    }
  },
  activated() {
    let {precision, singleHand} = config.region[this.region]
    this.localTick = this.tick.slice(-50)
    this.precision = precision
    this.singleHand = singleHand
    this.noAutoBottom = false
    this.count = 0
    this.toBottom()
  },
  methods: {
    getColor(val, base) {
      base = base === undefined ? this.statistic.PreClosePrice : base
      let f = val - base
      if(f > 0) return 'rise-color'
      if(f < 0) return 'fall-color'
      return 'draw-color'
    },
    getColorValue (val) {
      switch (val) {
        case 1:
          return '#258d01'
        case 2:
          return '#d4332f'
        default:
          return '#c8c8c8'
      }
    },
    manualScroll() {
      if(this.noAutoBottom) return
      this.count++
      if(this.count > 20) {
        this.noAutoBottom = true
        this.clearTimer()
      }
      this.timer = setTimeout(() => {
        this.clearTimer()
      }, 1000)
    },
    clearTimer() {
      this.count = 0
      clearTimeout(this.timer)
    },
    toBottom() {
      !this.noAutoBottom && this.$nextTick(() => {
        let container = this.$el.querySelector("#tick-content")
        container.scrollTop = container.scrollHeight
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .wrapper
    font-size .11rem
    padding 0 .03rem
  
  .title
    background white
    line-height .2rem
    color #8C9295
    padding-left .03rem

  .content
    height calc(100% - 0.2rem)
    overflow-y auto

  .item
    height .2rem
    font-size .11rem
    span
      display inline-block
      white-space nowrap

  .time
    width .3rem
  
  .price,.vol
    width .33rem
    text-align right
  .tiny-font
    font-size .1rem
    transform scale(0.9)

</style>